module.exports = __webpack_public_path__ + "static/media/zeirishi.com.f5699dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/zeirishi.com.png
// module id = 531
// module chunks = 0